<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getToken, setToken, removeToken} from '@/utils/auth';

export default {
  name: 'App',
  mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
    window.addEventListener('unload', e => this.unloadHandler(e));
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    window.removeEventListener('unload', e => this.unloadHandler(e));
  },
  created() {
    var userAgent = navigator.userAgent;
    console.log(userAgent);
    var isChrome = userAgent.indexOf('Chrome') > -1; //判断Chrome浏览器
    if (!isChrome) {
      this.$message({
        message: '建议使用谷歌浏览器',
        type: 'success',
        duration: 3000
      });

    }
    console.log(123213213);
  },
  methods: {
    beforeunloadHandler() {
      this._beforeUnload_time = new Date().getTime();
    },
    unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      // debugger;
      //判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        //如果是登录状态，关闭窗口前，移除用户
        removeToken();
        window.sessionStorage.clear();
      }
    }
  }
};
</script>

<style lang="scss">
.mce-menu.mce-animate{
  display: block!important;
}
.mce-window-head .mce-dragh {
  cursor: pointer !important;
  z-index: 0 !important;
}
.mce-window-head{
  display: none;
}

html {
  overflow-x: hidden;
  overflow-y: auto;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 260px;
  border: 1px solid red;
}

// .container {
//     padding: 24px 24px 24px 0;
//     background: #fff;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     flex-flow: wrap;
// }
.el-table .hidden-columns {
  visibility: visible !important;
}

.el-table,
.el-table__body-wrapper,
.el-table .cell {
  overflow: visible !important;
}

.my-swipe {
  // border: red 1px solid;
}
</style>
